"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _constants = require("../../azalea/constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // eslint-disable-next-line no-restricted-imports
var Birch = {
  buttonPadding: '0.5rem 1.5rem',
  checkboxSpacing: 2,
  containerPadding: '1rem',
  expandableMenuPadding: '1rem',
  iconSizeSmall: '1.25rem',
  iconSizeMedium: '1.5rem',
  fontMediumSize: '1rem',
  fontMediumLineHeight: '1.5rem',
  fontSmallSize: '.875rem',
  fontSmallLineHeight: '1.25rem',
  radioSize: '1.125rem',
  radioSpacing: 2,
  radioOffset: '4px',
  tableRowPadding: '1rem',
  toggleHeight: '1.375rem',
  toggleWidth: '2.75rem',
  toggleCircleSize: '1rem',
  toggleCircleTop: '0.185rem',
  toggleCircleTranslateX: '1.25em',
  toggleXIconTop: '0.0625rem',
  tooltipPadding: '1rem',
  typographyLegendSize: '0.8125rem'
};
var Dense = {
  buttonPadding: '0.4375rem 1rem',
  checkboxSpacing: 1,
  containerPadding: '1rem',
  expandableMenuPadding: '.75rem',
  iconSizeSmall: '1rem',
  iconSizeMedium: '1.25rem',
  fontMediumSize: '.875rem',
  fontMediumLineHeight: '1.25rem',
  fontSmallSize: '.75rem',
  fontSmallLineHeight: '1.125rem',
  radioSize: '1rem',
  radioSpacing: 1,
  radioOffset: '3px',
  tableRowPadding: '.75rem',
  toggleHeight: '1.2rem',
  toggleWidth: '2.4rem',
  toggleCircleSize: '.85rem',
  toggleCircleTop: '0.175rem',
  toggleCircleTranslateX: '1.2em',
  toggleXIconTop: '.1rem',
  tooltipPadding: '1rem',
  typographyLegendSize: '0.8125rem'
};
var ThemeNameToObject = {
  birch: Birch,
  dense: Dense
};

/*
 * This function is a workaround to support the Birch theme in Azalea. Previously, Azalea components were provided a
 * theme object that had a shape of { name: 'foobar' } and each component would need to check the theme name and change
 * styles accordingly. However, the correct way to use the themes is to have them provide the styles directly so that
 * individual components dont have to have conditional logic basedo on the theme name.
 *
 * Ultimately, this method should be removed once all Azalea components have been updated to use the Birch themes by default.
 * That being said, offering this backward compatibility is a safer approach to rolling out genuine themeing in Birch.
 */
var supportAzaleaBirchLiteTheme = function supportAzaleaBirchLiteTheme(theme) {
  return _objectSpread(_objectSpread({}, theme), {}, {
    name: _constants.ReskinThemes.BIRCH
  });
};
var getTheme = function getTheme(themeKey) {
  var themeObject = themeKey in ThemeNameToObject ? ThemeNameToObject[themeKey] : Birch;
  return supportAzaleaBirchLiteTheme(themeObject);
};
var _default = exports["default"] = getTheme;